import React, { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const ParentNavigation = createContext(null);
const parentPath = /^\/(student360|puanlarim|avatarim|odemelerim)(?:\/|$)|^\/mini-tasks\/parent(?:\/|$)/;
const fullNavigation = (to) => { window.location.assign(to); };

export function useParentNavigate() { return useContext(ParentNavigation) || fullNavigation; }

export function ParentNavigationProvider({ children }) {
  const navigate = useNavigate();
  const go = (to) => {
    const target = new URL(to, window.location.origin);
    if (target.origin === window.location.origin && parentPath.test(target.pathname)) {
      navigate(target.pathname + target.search + target.hash);
    } else fullNavigation(to);
  };
  return <ParentNavigation.Provider value={go}>{children}</ParentNavigation.Provider>;
}

export function ParentLink({ href, children, ...props }) {
  const go = useContext(ParentNavigation);
  return <a {...props} href={href} onClick={(event) => {
    if (go && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey
      && !event.shiftKey && !event.altKey && !props.target && !props.download) {
      event.preventDefault();
      go(href);
    }
  }}>{children}</a>;
}
